import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from 'antd';
import 'react-phone-input-2/lib/style.css';
import { useReturnFormFields } from '../../../../hooks/useReturnFormFields';
import { useRegisterValues } from '../../../../providers/RegisterProvider';
import { Tooltip } from 'components/Shared/Tooltip';
import { Form, FormItem } from 'components/UI/Form';
import { Input } from 'components/UI/Input';
import * as StyledShared from '../../styles';
import { AccountFormFields } from 'constants/account/account-form-fields';
import { IS_KIOSK_AM_MODE } from 'constants/app/configs';
import { IFormField } from 'interfaces';

const returnFormFields = (field: IFormField) => {
  switch (field.name) {
    case AccountFormFields.Phone:
      return (
        <FormItem label={field.label} name={field.name} rules={field.rules}>
          <StyledShared.PhoneNumberInput
            containerClass="phone-input-container"
            inputProps={{
              name: 'phone',
              autoFocus: false,
              id: 'phone'
            }}
            dropdownClass="bottom"
            country="am"
          />
        </FormItem>
      );
    case AccountFormFields.Password:
    case AccountFormFields.PasswordConfirmation:
      return (
        <FormItem label={field.label} name={field.name} rules={field.rules}>
          <Input type="password" />
        </FormItem>
      );
    case AccountFormFields.TermsAndConditions:
      return (
        <FormItem
          name="terms_and_conditions"
          initialValue={false}
          valuePropName="checked"
          rules={field.rules}
          style={{ marginBottom: 0 }}
        >
          <Checkbox>
            <StyledShared.Label
              dangerouslySetInnerHTML={{ __html: field.label }}
              $required
            />
          </Checkbox>
        </FormItem>
      );
    case AccountFormFields.PromotionalEmails:
      return (
        <FormItem
          name="subscribed_to_news_letter"
          initialValue={false}
          valuePropName="checked"
        >
          <Checkbox>
            <StyledShared.Label
              dangerouslySetInnerHTML={{ __html: field.label }}
            />
          </Checkbox>
        </FormItem>
      );
    default:
      return (
        <FormItem
          label={
            <>
              {field.label}
              {field.tooltip && <Tooltip>{field.tooltip}</Tooltip>}
            </>
          }
          name={field.name}
          rules={field.rules}
          isWhitespaceForbidden
        >
          <Input />
        </FormItem>
      );
  }
};

export const RegisterCollectorStepTwo = () => {
  const { form } = useRegisterValues();
  const { t } = useTranslation();

  const formFields = useReturnFormFields(form, [
    AccountFormFields.Email,
    AccountFormFields.UserName,
    AccountFormFields.Phone,
    AccountFormFields.Occupation,
    AccountFormFields.Password,
    AccountFormFields.PasswordConfirmation,
    AccountFormFields.TermsAndConditions,
    AccountFormFields.PromotionalEmails
  ]);

  return (
    <StyledShared.Wrapper>
      <Form layout="vertical" form={form} name="registerCollector">
        <input
          className="fake-input"
          id={AccountFormFields.Email}
          name={AccountFormFields.Email}
          style={{
            position: 'absolute',
            left: '-9999px',
            top: '-9999px'
          }}
        />
        <input
          className="fake-input"
          name={AccountFormFields.Password}
          type={AccountFormFields.Password}
          style={{
            position: 'absolute',
            left: '-9999px',
            top: '-9999px'
          }}
        />
        {formFields.map(field => (
          <Fragment key={field.name}>{returnFormFields(field)}</Fragment>
        ))}
        {IS_KIOSK_AM_MODE && (
          <FormItem>
            <StyledShared.AgeLimitMessage>
              {t('account.ageLimitMessage')}
            </StyledShared.AgeLimitMessage>
          </FormItem>
        )}
      </Form>
    </StyledShared.Wrapper>
  );
};
